// extracted by mini-css-extract-plugin
module.exports = {"header":"header","svelte-1uix7d8":"svelte-1uix7d8","disabled":"disabled"};